import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["category", "list", "group"];

    GROUPS = [];

    connect()
    {
        if(this.groupTargets.length == 0) return;

        this.GROUPS = this.groupTargets.map(target => target.cloneNode(true));

        this.categoryTargets.forEach(category => category.addEventListener("click", e =>
        {
            this.categoryTargets.forEach(cat => cat.classList.remove("selected"));
            category.classList.add("selected");


            let filtered = category.dataset["code"] == "All" ? this.GROUPS : 
                            this.GROUPS.filter(group => category.dataset["code"].toLowerCase() == group.dataset["code"].toLowerCase() )

            // setTimeout(() => {

                this.listTarget.innerHTML = "";
                this.listTarget.append(...filtered);


            // }, 50);
            

            // this.listTarget.firstElementChild.classList.add("hidden");
            // this.listTarget.firstElementChild.innerHTML = "";
            // this.listTarget.firstElementChild.append(...filtered);
            // this.listTarget.firstElementChild.classList.remove("hidden");

        }))
    }

}